import { NivosTheme } from 'types/theme'

export const LIGHT_MODE: NivosTheme = {
  primaryColor: '#f8f8f2',
  secondaryColor: '#282a36',
  tertiaryColor: '#343747',
  quaternaryColor: '#e8e8e8'
}

export const NIGHT_MODE: NivosTheme = {
  primaryColor: '#171818',
  secondaryColor: '#c9c6c2',
  tertiaryColor: '#e8e8e8',
  quaternaryColor: '#212324',
  custom: '#656875'
}

export const ROYAL_MODE: NivosTheme = {
  primaryColor: '#f8f8f2',
  secondaryColor: '#524200',
  tertiaryColor: '#725c00',
  quaternaryColor: '#efefef'
}

export const THEME_STRING_DIR: { [id: string]: NivosTheme } = {
  LIGHT_MODE,
  NIGHT_MODE,
  ROYAL_MODE
}
